import React, { Component, createFactory } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import Loader from 'react-loader-spinner';
import { ToastContainer, toast } from "react-toastify";
import $ from 'jquery';
import JSONPretty from 'react-json-pretty';


export default class OutboundCallTask extends Component {
    constructor() {
        super();
        this.state = {
            data: [],
            successResp: true,
            pageNum: null,
            customParams: "",
            displayCustomParamsModel: false
        }
    }

    componentDidMount = () => {
        setTimeout(() => {
            this.fetchOutboundCallTaskDataApi();
        }, 300);

        var thisController = this;
        document.addEventListener("projectChanged", function (event) {
            thisController.projectId = event.projectId;
            thisController.fetchOutboundCallTaskDataApi(event.projectId);
        });
    }

    notifyWarning = (message) => {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;
            {message}</b>, {
            position: "top-center"
        });
    }

    fetchOutboundCallTaskDataApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        let outboundCallTaskComp = this;
        let data = {
            projectId: projectId,
            batchId: outboundCallTaskComp.props.location.state.batchId
        }
        $.ajax({
            url: "/api/outboundcall-Task",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            data: data,
            success: function (res) {
                if (res.success === true) {
                    outboundCallTaskComp.setState({
                        data: res['result']
                    });
                } else {
                    outboundCallTaskComp.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    notifyFailToLoad = (response) => {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    notifySuccess = (message) => {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg"
            style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;
            {message}</b>, {
            position: "top-center",

        });
    }

    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.fetchOutboundCallTaskDataApi()
        this.setState({ disabled: false })
    }

    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }

    goBack = () => {
        this.props.history.push('/projectmgmt/test-and-deploy/DistributionWidget/telephony-setting/outreach-programs');
        this.setState(this.setState)
    }

    handleExecuteAll = () => {
        var outboundCallTaskComp = this;
        var formData = new FormData();
        formData.append("projectId", localStorage.getItem("currentProjectId"));
        formData.append("batchId", outboundCallTaskComp.props.location.state.batchId);

        $.ajax({
            url: '/api/outBoundTask-ExecuteAll',
            async: false,
            method: 'POST',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token")
            },
            data: formData,
            processData: false,
            contentType: false,
            success: function (data) {
                if (data.success === true) {
                    outboundCallTaskComp.notifySuccess("OutBound Call Batch Execution is Successful.")
                    outboundCallTaskComp.fetchOutboundCallTaskDataApi();
                } else {
                    outboundCallTaskComp.notifyFailToLoad(data.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    handleClickExecuteUnsuccessful = () => {
        var outboundCallTaskComp = this;
        var formData = new FormData();
        formData.append("projectId", localStorage.getItem("currentProjectId"));
        formData.append("batchId", outboundCallTaskComp.props.location.state.batchId);
        $.ajax({
            url: '/api/outBoundTask-ExecuteUnSuccessful',
            async: false,
            method: 'POST',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            data: formData,
            processData: false,
            contentType: false,
            success: function (data) {
                if (data.success === true) {
                    outboundCallTaskComp.notifySuccess("OutBound Call Batch Execution is Successful.")
                    outboundCallTaskComp.fetchOutboundCallTaskDataApi();
                } else {
                    outboundCallTaskComp.notifyFailToLoad(data.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    handleClickDownload = () => {
        let projectId = localStorage.getItem("currentProjectId");
        let batchId = this.props.location.state.batchId;
        var url = "/api/download-outBoundBatch?projectId=" + projectId + "&batchId=" + batchId;
        window.location.href = url;
    }

    render() {
        const columns = [
            {
                Header: <b>Batch name</b>,
                accessor: 'batch-name',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{
                        width: '98%', padding: '8px',
                        paddingLeft: '2px'
                    }}
                    contentEditable={false}
                    suppressContentEditableWarning
                    type="text" id={"batchName" + props.index}
                >{props.original.batchName}</div>)
            },
            {
                Header: <b>User Name</b>,
                accessor: 'user-name',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{
                        width: '98%', padding: '8px',
                        paddingLeft: '2px'
                    }}
                    contentEditable={false}
                    suppressContentEditableWarning
                    type="text" id={"userName" + props.index}
                >{props.original.userName}</div>)
            },
            {
                Header: <b>Contact Number</b>,
                accessor: 'contactNum',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{
                        width: '98%', padding: '8px',
                        paddingLeft: '2px'
                    }}
                    contentEditable={false}
                    suppressContentEditableWarning
                    type="text" id={"contactNum" + props.index}
                >{props.original.contactNum}</div>)
            },
            {
                Header: <b>Status</b>,
                accessor: 'status',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{ width: '98%', padding: '8px', paddingLeft: '2px' }}
                    contentEditable={false}
                    suppressContentEditableWarning
                    type="text" id={"status" + props.index}
                >{props.original.status}</div>
                )
            }, {
                Header: <b>Date</b>,
                accessor: 'date',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{ width: '98%', padding: '8px', paddingLeft: '2px' }}
                    contentEditable={false}
                    suppressContentEditableWarning
                    type="text" id={"date" + props.index}
                >{props.original.date}</div>
                )
            }, {
                Header: <b>Time</b>,
                accessor: 'time',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{ width: '98%', padding: '8px', paddingLeft: '2px' }}
                    contentEditable={false}
                    suppressContentEditableWarning
                    type="text" id={"time" + props.index}
                >{props.original.time}</div>
                )
            },
            {
                Header: <b>Outcome</b>,
                accessor: 'outcome',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{ width: '98%', padding: '8px', paddingLeft: '2px' }}
                    contentEditable={false}
                    suppressContentEditableWarning
                    type="text" id={"outcome" + props.index}
                >{props.original.outcome}</div>
                )
            },
            {
                Header: <b>Action</b>,
                accessor: "action",
                sortable: false,
                width: 150,
                Cell: props => (
                    <div Align="center" id="action">
                        <button className="btn2 table-action-button"
                            onClick={(e) => {
                                this.setState({ customParams: props.original.customParams, displayCustomParamsModel: true })

                            }}>
                            View Params
                        </button>
                    </div>

                )
            },
        ]
        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={this.state.successResp ? false : true}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center' }}
                />
                <ToastContainer className="Toast-at-center" />

                <div style={{ background: "#F9F9FB", display: this.state.successResp ? 'block' : 'none' }} className="container-fluid">
                    {/* for toaster */}
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />

                    {/* for reactTable */}
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />

                    {/*for dialog component */}
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-3">
                                <img src="./assets/images/arrow.svg"
                                    style={{ paddingRight: "30%", cursor: 'pointer' }}
                                    onClick={this.goBack}
                                />
                            </div>
                            <div className="col-sm-3">
                                <h6 className="nav-item" style={{
                                    color: '#282a65',
                                    marginTop: '12px'
                                }}>OutBound Call Task Details</h6>
                            </div>
                            {/* Add button and refresh button*/}
                            <div className="col-sm-6" Align='right'>
                                <button style={{ display: "none"}} onClick={this.handleExecuteAll} className="btn action-button">
                                    Execute All
                                </button>
                                <button onClick={this.handleClickExecuteUnsuccessful} className="btn action-button">
                                    Retry Unsuccessful Calls
                                </button>

                                <button onClick={this.refreshData} className="btn action-button" title="Refresh">
                                    <img src="./assets/images/refresh_white_24dp.png"></img>
                                </button>
                            </div>

                        </div>
                    </div>
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row" >
                                <div className="col-lg-12 ">
                                    <div className="card" >
                                        <ReactTable
                                            data={this.state.data}
                                            columns={columns}
                                            defaultPageSize={10}
                                            pageSizeOptions={[5, 10, 15]}
                                            onPageChange={this.onPageChange}
                                            page={this.state.pageNum}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal" style={{ display: this.state.displayCustomParamsModel ? 'block' : 'none', width: "auto" }}>
                    <div className="modal-dialog">
                        <div className="modal-content" style={{ height: "100%" }}>
                            <div className="modal-header noBorder">
                                <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={(e) => this.setState({ displayCustomParamsModel: false })}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                        <path d="M0 0h24v24H0z" fill="none" />
                                    </svg>
                                </button>
                            </div>
                            <div className="modal-body">
                                <JSONPretty data={this.state.customParams}
                                    style={{
                                        height: 'auto', border: 'none',
                                        overflowY: "hidden"
                                    }}></JSONPretty>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/OutboundCallTask.js